import axios from 'axios';

const production = !process.env.REACT_APP_NODE_ENV || process.env.REACT_APP_NODE_ENV === "production";
const API_BASE_URL =production ? process.env.REACT_APP_BASE_URL_PROD: process.env.REACT_APP_BASE_URL_DEV;
const API_AUTH_TOKEN = localStorage.getItem('token');

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${API_AUTH_TOKEN}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Redirect user to the login page
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);
export const getJobs = async () => {
  try {
    const response = await axiosInstance.get('/cronjob');
    if(response.status === 401){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
      return null;
    }else{
      return response.data;
    }
   
  } catch (error) {
    console.error('Error fetching advertisers:', error);
    throw error;
  }
};

export const getOfferById = async (id) => {
    try {
      const response = await axiosInstance.get(`/offer/${id}`);
      if(response.status === 401){
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        window.location.href = '/auth/login';
        return null;
      }else{
        return response.data;
      }
     
    } catch (error) {
      console.error('Error fetching advertisers:', error);
      throw error;
    }
  };

  export const getOffersFiltered = async (query) => {
    try {
      const response = await axiosInstance.get(`/offers/filter?query=${JSON.stringify(query)}`);
      if(response.status === 401){
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        window.location.href = '/auth/login';
        return null;
      }else{
        return response.data;
      }
     
    } catch (error) {
      console.error('Error fetching advertisers:', error);
      throw error;
    }
  };

export const addNewCronjob = async (job) => {
  try {
    const response = await axiosInstance.put('/cronjob/schedule', job);
    if(response.status === 401){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
      return null;
    }else{
      return response.data;
    }
   
  } catch (error) {
    console.error('Error adding advertiser:', error);
    throw error;
  }
};

export const updateJob = async (id, updatedJob) => {
  try {
    const response = await axiosInstance.patch(`/cronjob/${id}`, updatedJob);
    if(response.status === 401){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
      return null;
    }else{
      return response.data;
    }
   
  } catch (error) {
    console.error('Error updating advertiser:', error);
    throw error;
  }
};

export const deleteJob = async (id) => {
  try {
    const response = await axiosInstance.delete(`/cronjob/${id}`);
    if(response.status === 401){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
      return null;
    }else{
      return response.data;
    }
   
  } catch (error) {
    console.error('Error deleting advertiser:', error);
    throw error;
  }
};
